import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Almaty_obl.png'
import _imports_1 from '@/assets/images/almatyObl1.jpg'
import _imports_2 from '@/assets/images/almatyObl2.jpg'
import _imports_3 from '@/assets/images/almatyObl3.jpg'
import _imports_4 from '@/assets/images/almatyObl4.jpg'
import _imports_5 from '@/assets/images/almatyObl5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Алматинская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Алматинская область – один из самых перспективных с точки зрения туризма казахстанских регионов. Здесь есть все, что сможет привлечь иностранного и местного туриста: городские достопримечательности, работающие круглый год высокогорные курорты, национальные парки в различных природных зонах. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Туризм Региона")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Статистика туризма Алматинской области показывает: наиболее популярными у путешественников являются экскурсионные маршруты, построенные на контрасте пейзажей. Например, пользуется успехом тур, начинающийся на высокогорном Большом Алматинском озере, расположенном на высоте 2500 метров над уровнем моря и заканчивающийся в тот же день в низинной пустыне около Поющего бархана в национальном парке "),
          /*#__PURE__*/_createVNode("strong", null, "«Алтын-Эмель».")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Среди популярных туристических дестинаций региона – местные живописные озера в национальном парке "),
          /*#__PURE__*/_createVNode("strong", null, "«Кольсай колдери», Долина замков в Чарынском каньоне"),
          /*#__PURE__*/_createTextVNode(", и там же – "),
          /*#__PURE__*/_createVNode("strong", null, "реликтовая Ясеневая роща"),
          /*#__PURE__*/_createTextVNode(", которая, как утверждают ученые, пережила ледниковый период. Охотно путешественники посещают водопад "),
          /*#__PURE__*/_createVNode("strong", null, "Бурхан-Булак"),
          /*#__PURE__*/_createTextVNode(" высотой 120 метров, спрятанный в живописном ущелье. Статистика в сфере туризма говорит, что туры сюда чаще покупают иностранные туристы, а местным жителям в последние годы более интересны Тургеньские водопады. Здесь организуются пешие экскурсии, включающие посещение форелевого хозяйства, страусиной фермы и этнопарка под открытым небом. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "26824")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "18,3")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "829431")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "4751")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Туристической Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Любой туроператор может найти в Алматинской области свою нишу. Можно развивать высокогорный туризм – круглый год отдыхающих ждут курорты "),
          /*#__PURE__*/_createVNode("strong", null, "«Шымбулак», «Лесная Сказка», «Ак-Булак», «Табаган»"),
          /*#__PURE__*/_createTextVNode(". Пользуются популярностью поездки на плато "),
          /*#__PURE__*/_createVNode("strong", null, "Асы"),
          /*#__PURE__*/_createTextVNode(" – это место обладает уникальными, как будто внеземными астроклиматическими условиями. Любителей древностей заинтересует экскурсия в урочище "),
          /*#__PURE__*/_createVNode("strong", null, "Тамгалы-Тас"),
          /*#__PURE__*/_createTextVNode(" с отлично сохранившимися наскальными рисунками, а поправить свое здоровье можно не только высоко в горах, но и на берегах целебного озера "),
          /*#__PURE__*/_createVNode("strong", null, "Алаколь"),
          /*#__PURE__*/_createTextVNode(". Поклонникам исторического этнотуризма можно предложить тур в долину "),
          /*#__PURE__*/_createVNode("strong", null, "Шалкодесу"),
          /*#__PURE__*/_createTextVNode(". Это место лучше посещать летом – здесь установлены настоящие юрты степных кочевников, в которых можно погостить. ")
        ]),
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Алматинской области? Несмотря на множество существующих предложений, в области постоянно открываются новые туристические локации. Организуются новые и обустраиваются имеющиеся места размещения путешественников, развивается придорожная инфраструктура. ")
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "regio-swiper" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}